import React from 'react';

const Bard_Email = () => {
  return (
    <div>
      <h1>Bard_Email</h1>
      <p>This is the Bard_Email component.</p>
    </div>
  );
};

export default Bard_Email;
